import { Controller } from "@hotwired/stimulus";

// Cycles the colour theme: system → light → dark. Persists the choice and
// applies `.light` / `.dark` on <html>. Default is "system".
const ORDER = ["system", "light", "dark"];

export default class extends Controller {
  static targets = ["systemIcon", "lightIcon", "darkIcon"];

  connect() {
    this.media = window.matchMedia("(prefers-color-scheme: dark)");
    this.onSystemChange = () => {
      if (this.current === "system") this.apply();
    };
    this.media.addEventListener("change", this.onSystemChange);
    this.reflect();
  }

  disconnect() {
    this.media?.removeEventListener("change", this.onSystemChange);
  }

  get current() {
    return localStorage.getItem("theme") || "system";
  }

  cycle() {
    const next = ORDER[(ORDER.indexOf(this.current) + 1) % ORDER.length];
    localStorage.setItem("theme", next);
    this.apply();
    this.reflect();
  }

  apply() {
    const dark = this.current === "dark" || (this.current === "system" && this.media.matches);
    const el = document.documentElement;
    el.classList.toggle("dark", dark);
    el.classList.toggle("light", !dark);
  }

  reflect() {
    const t = this.current;
    if (this.hasSystemIconTarget) this.systemIconTarget.classList.toggle("hidden", t !== "system");
    if (this.hasLightIconTarget) this.lightIconTarget.classList.toggle("hidden", t !== "light");
    if (this.hasDarkIconTarget) this.darkIconTarget.classList.toggle("hidden", t !== "dark");
  }
}
